(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/game-card/ticket-card.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/game-card/ticket-card.js');

'use strict';

const {
  Card,
  CardHeader,
  CardBody,
  CardExpandableBody
} = svs.ui.ReactCard;
const Brand = svs.ui.ReactBrand;
const {
  Image
} = svs.content.image_v2;
const TicketCard = _ref => {
  let {
    product,
    price,
    skin = {},
    isExpandable,
    packageIsClosed
  } = _ref;
  return React.createElement("div", {
    className: "gp-game-card"
  }, React.createElement(Card, {
    align: "center",
    expandable: isExpandable,
    className: packageIsClosed ? 'card-faded' : ''
  }, React.createElement(CardHeader, {
    className: "header-".concat(product.toLowerCase())
  }, React.createElement("div", null, React.createElement(Brand, {
    brand: product.toLowerCase(),
    emblem: true,
    size: 150
  }), React.createElement("p", {
    className: "card-header-jackpot"
  }, "Vinn upp till 100 000 kr/m\xE5n i 25 \xE5r"))), React.createElement(CardExpandableBody, null, React.createElement("div", null, React.createElement(Image, {
    image: skin
  }))), React.createElement(CardBody, null, React.createElement("p", {
    className: "card-body-header"
  }, packageIsClosed ? 'Stängt för spel' : 'Skrapa direkt'), React.createElement("p", {
    className: "card-tickets f-content"
  }, "1 ", product), React.createElement("p", {
    className: "card-extra-info"
  }, "En lott ", price, " kr"))));
};
svs.gamePackage.components.TicketCard = TicketCard;

 })(window);